import { useParams, Link } from "react-router-dom";
import { getCardBySlug } from "@/data/businessCards";
import { BusinessCard } from "@/components/BusinessCard";

export default function DigitalBusinessCard() {
  const { slug } = useParams();
  const person = getCardBySlug(slug);

  const bgStyle = {
    minHeight: "100vh",
    background: "#EEF3FA",
    backgroundImage:
      "radial-gradient(rgba(11,31,58,.06) 1.4px, transparent 1.4px)",
    backgroundSize: "20px 20px",
  };

  if (!person) {
    return (
      <div style={bgStyle} className="flex flex-col items-center justify-center p-6 text-center" data-testid="card-not-found">
        <h1 className="text-2xl font-bold" style={{ color: "#0B1F3A" }}>Visitenkarte nicht gefunden</h1>
        <p className="text-muted-foreground mt-2">Diese digitale Visitenkarte existiert nicht.</p>
        <Link to="/" className="mt-6 text-sm font-medium" style={{ color: "#F39200" }}>Zur Startseite</Link>
      </div>
    );
  }

  return (
    <div style={bgStyle} className="flex items-center justify-center p-4 py-10">
      <BusinessCard person={person} />
    </div>
  );
}
